var _line, _line2, _line3, _line4, _line5, _line6, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpotScalingDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 186,
    viewBox: "0 0 330 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 164.748,
    x2: 329.196,
    y2: 164.748,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 134.642,
    x2: 329.196,
    y2: 134.642,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 104.536,
    x2: 329.196,
    y2: 104.536,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 74.431,
    x2: 329.196,
    y2: 74.431,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 44.3253,
    x2: 329.196,
    y2: 44.3253,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 14.2202,
    x2: 329.196,
    y2: 14.2202,
    stroke: "white",
    strokeOpacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.629,
    y: 44.6721,
    width: 16.3225,
    height: 120.271,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4014,
    y: 37.7996,
    width: 16.3225,
    height: 127.144,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0329,
    y: 30.0679,
    width: 16.3225,
    height: 134.876,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111.805,
    y: 23.1951,
    width: 16.3225,
    height: 141.748,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.209 0L164.209 185.561",
    stroke: "white",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.629,
    y: 131.439,
    width: 16.3225,
    height: 33.5041,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.99756,
    y: 44.6721,
    width: 16.3225,
    height: 120.271,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.99756,
    y: 131.439,
    width: 16.3225,
    height: 33.5041,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4014,
    y: 128.003,
    width: 16.3225,
    height: 36.9404,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0329,
    y: 123.707,
    width: 16.3225,
    height: 41.2358,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111.805,
    y: 123.707,
    width: 16.3225,
    height: 41.2358,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 138.437,
    y: 14.6045,
    width: 16.3225,
    height: 150.339,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 138.437,
    y: 121.13,
    width: 16.3225,
    height: 43.8131,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 173.659,
    y: 71.3038,
    width: 17.1816,
    height: 93.6397,
    rx: 8.5908,
    fill: "#DF8981"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 200.291,
    y: 67.8672,
    width: 16.3225,
    height: 97.076,
    rx: 8.16126,
    fill: "#DF8981"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 226.063,
    y: 71.3038,
    width: 16.3225,
    height: 93.6397,
    rx: 8.16126,
    fill: "#DF8981"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 252.694,
    y: 67.8672,
    width: 16.3225,
    height: 97.076,
    rx: 8.16126,
    fill: "#DF8981"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 278.467,
    y: 79.0354,
    width: 16.3225,
    height: 85.908,
    rx: 8.16126,
    fill: "#DF8981"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 173.659,
    y: 109.103,
    width: 17.1816,
    height: 55.8402,
    rx: 8.5908,
    fill: "#AAB3FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 200.291,
    y: 113.399,
    width: 16.3225,
    height: 51.5448,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 226.063,
    y: 117.694,
    width: 16.3225,
    height: 47.2494,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 252.694,
    y: 121.989,
    width: 16.3225,
    height: 42.954,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 173.659,
    y: 140.889,
    width: 17.1816,
    height: 24.0542,
    rx: 8.5908,
    fill: "#7871C9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 200.291,
    y: 140.889,
    width: 16.3225,
    height: 24.0542,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 226.063,
    y: 140.889,
    width: 16.3225,
    height: 24.0542,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 252.694,
    y: 140.889,
    width: 16.3225,
    height: 24.0542,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 278.467,
    y: 121.989,
    width: 16.3225,
    height: 42.954,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 278.467,
    y: 142.607,
    width: 16.3225,
    height: 22.3361,
    rx: 8.16126,
    fill: "#7871C9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 305.098,
    y: 81.6125,
    width: 16.3225,
    height: 83.3308,
    rx: 8.16126,
    fill: "#DF8981"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 305.098,
    y: 121.989,
    width: 16.3225,
    height: 42.954,
    rx: 8.16126,
    fill: "#AAB3FF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 305.098,
    y: 142.607,
    width: 16.3225,
    height: 22.3361,
    rx: 8.16126,
    fill: "#7871C9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotScalingDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spot-scaling-dark.b161336b78dfb165c21da410177f8223.svg";